<div *ngIf="initData">
    <pk-poker-publicpage-promotions [initData]="initData"> </pk-poker-publicpage-promotions>
</div>
